import React, { useState,useEffect } from 'react';
import clsx from 'clsx';
import './Header.css';
import './../../HomePage/Home.css'
import StarIcon from '@material-ui/icons/Star';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import PersonIcon from '@material-ui/icons/Person';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import DateRangeIcon from '@material-ui/icons/DateRange'
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import LocalMallIcon from '@material-ui/icons/LocalMall'
import {Link , useHistory} from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAlignJustify } from '@fortawesome/free-solid-svg-icons'
import  StarBorderIcon from '@material-ui/icons/StarBorder';
import logo from "../../assets/images/logo2.png";
import CloseIcon from '@material-ui/icons/Close'
import { HttpService } from '../../service/HttpService';

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
  
});

export default function TemporaryDrawer() {
  const classes = useStyles();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
const [role,setRole]=useState('')
const [user,setUser] = useState({})
const [points,setPoints]=useState(0)

const httpService = new HttpService();
  const history = useHistory();

  useEffect(() => {
    getUserInfo()
    getTotalPoints()
}, [])

  
const getUserInfo=()=>{
     
  var obj = {};
  httpService.getApi2('account', localStorage.getItem('token')).then(response => {
      localStorage.setItem("user",JSON.stringify(response.data))
      obj = JSON.stringify(response.data)
      obj = JSON.parse(obj);
      setUser({...obj});
      setRole(obj.authorities[0])
      
   
  })
 
     
  }

   
const getTotalPoints = () => {
  httpService.getApi('user/balance').then((response) => {
    if (response.data.balance != null){
        localStorage.setItem('balance',response.data.balance)
      setPoints(response.data.balance)
    }
   
  }, (error) => {
    console.log(error);
  });
}
  
  
  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const redirect =(view)=>{
    history.push({
      pathname: view
    })
  }
  

  const list = (anchor) => (
    <div
    style={{backgroundColor:'#c94d3d',borderBottomLeftRadius:'20px',borderBottomRightRadius:'20px'}}
  
      className={clsx(classes.list, {
        [classes.fullList]: anchor === 'top' || anchor === 'bottom',
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >

      <List>
      <CloseIcon onClick={(toggleDrawer(anchor, false))} />
      <ListItem style={{marginTop:'10%',color:'white'}} button  component="a">
        <ListItemIcon><AccountCircleIcon fontSize="large" style={{ color: "white" }}/>   <p style={{color:'white',marginLeft:'5px'}}>Hello, <p style={{fontWeight:'700'}}>{user.firstName}</p></p></ListItemIcon>
        </ListItem>
        <ListItem button  component="a" onClick={()=>redirect('/home')}>
        <ListItemIcon><PersonIcon /> <p style={{color:'white',marginLeft:'5px'}}>Home</p></ListItemIcon>
        </ListItem>

        <ListItem button  component="a" onClick={()=>redirect('/qrcode')}>
        <ListItemIcon><LocalMallIcon /><p style={{color:'white',marginLeft:'5px'}}>{role!='ROLE_VOUCHER_ADMIN' ? <>Upload Points</>:<>Validate Redemption</>}</p></ListItemIcon>
        </ListItem>
        {role!='ROLE_VOUCHER_ADMIN' &&
        <ListItem button  component="a" onClick={()=>redirect('/gifts')}>
        <ListItemIcon><StarBorderIcon /><p style={{color:'white',marginLeft:'5px'}}>Redeem </p></ListItemIcon>
        </ListItem>
}

        <ListItem button  component="a"  onClick={()=>redirect('/transactions')}>
        <ListItemIcon><DateRangeIcon /> <p style={{color:'white',marginLeft:'5px'}}>History </p></ListItemIcon>
        </ListItem>
        <ListItem button  component="a"  onClick={()=>redirect('/playvideo')}>
        <ListItemIcon><PlayCircleOutlineIcon /> <p style={{color:'white',marginLeft:'5px'}}>How To Use Machine</p></ListItemIcon>
        </ListItem>
        <ListItem button  component="a" href="/ui/rvm">
        <ListItemIcon><ExitToAppIcon />  <p style={{color:'white',marginLeft:'5px'}}> Logout</p></ListItemIcon>
        </ListItem>
      </List>
      {/* <Divider /> */}
    </div>
  );

  return (
    <div >
      {['left'].map((anchor) => (
        <React.Fragment key={anchor}>
          {/* <Button onClick={toggleDrawer(anchor, true)}> */}
          {/* <i class="fas fa-align-justify"></i> */}
          {/* <FontAwesomeIcon icon={faAlignJustify} size={'2x'}/> */}
          {/* <svg class="svg-inline--fa fa-align-justify fa-w-14 fa-2x" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="align-justify" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""></svg> */}
          {/* </Button> */}
          <div className="details">
            <div className="profile-container white" onClick={toggleDrawer(anchor, true)}>
              <div className="profile-image">
                <PersonIcon style={{ marginTop: '6px' }} />
              </div>
              <div className="profile-name">{user.firstName}</div>
            </div>
            <div className="element-container">
              {/* <div className="bottles white" title="Bottles">
                            <img src={bottle} alt="bottles" id="bottle-rotate" width="22px" height="28px" />
                            <div className="bottles-value">17</div>
                        </div> */}
              <div className="points white" title="Points">
                <StarIcon style={{ "color": "#EB7E1F", marginBottom: '5px' }} />
                <div className="points-value">{points}</div>
              </div>
            </div>
          </div>
          <Drawer anchor={anchor} open={state[anchor]} onClose={toggleDrawer(anchor, false)}>
            <div style={{
              backgroundColor: '#eae6e4', width: '100%', height: '100%', display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}>


              {list(anchor)}
              <div style={{ flex: 'auto', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <img style={{
                  height: 'auto',

                  maxWidth: '165px'
                }} src={logo} alt="logo-imgg" /></div>
            </div>
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}
